import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import img from "../assets/video-banner.webp";
import webmvideo from "../assets/video/buzz-website-video.webm";
import mp4video from "../assets/video/buzz-website-video.mp4";
import battery from "../assets/service-imgs/battery-problem.webp";
import screen from "../assets/service-imgs/glass-prolbme.webp";
import camera from "../assets/service-imgs/camera-problem.webp";
import speaker from "../assets/service-imgs/speaker-problem.webp";
import display from "../assets/service-imgs/broken-display.webp";
import network from "../assets/service-imgs/network-loss.webp";
import buttons from "../assets/service-imgs/button-problems.webp";
import software from "../assets/service-imgs/softawre-rpoblem.webp";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Navigation, Autoplay } from "swiper";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";

import SingleService from "./SingleService";

SwiperCore.use([Pagination, Navigation, Autoplay]);
gsap.registerPlugin(ScrollTrigger);

const services = [
  { img: battery, title: "Батерија" },
  { img: display, title: "Екран" },
  { img: camera, title: "Камера" },
  { img: speaker, title: "Звучник" },
  { img: screen, title: "Стакло" },
  { img: network, title: "Мрежа" },
  { img: buttons, title: "Копчиња" },
  { img: software, title: "Софтвер" },
];

function ServiceHome() {
  const [showSlider, setShowSlider] = useState(false);
  const [slides, setSlides] = useState(3);
  const sectionRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setShowSlider(window.innerWidth < 768);
      setSlides(window.innerWidth < 450 ? 2 : 3);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useLayoutEffect(() => {
    if (!sectionRef.current) {
      return undefined;
    }

    const ctx = gsap.context(() => {
      gsap.from(".services__video", {
        y: 46,
        opacity: 0,
        duration: 0.95,
        ease: "power3.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 78%",
        },
      });

      gsap.from(".services__title > *", {
        y: 30,
        opacity: 0,
        duration: 0.8,
        stagger: 0.08,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".services__title",
          start: "top 84%",
        },
      });

      gsap.from(".buzz-service-item, .service__mobile-card", {
        y: 26,
        opacity: 0,
        duration: 0.7,
        stagger: 0.05,
        ease: "power3.out",
        scrollTrigger: {
          trigger: "#buzz-slider",
          start: "top 86%",
        },
      });
    }, sectionRef);

    return () => ctx.revert();
  }, [showSlider]);

  return (
    <section className="services__containerhp" id="service" ref={sectionRef}>
      <div className="services__wrapperhp container">
        <div className="services__video">
          <video poster={img} id="bgvid" playsInline autoPlay muted loop>
            <source src={webmvideo} type="video/webm" />
            <source src={mp4video} type="video/mp4" />
          </video>
        </div>

        <div className="services__title">
          <h2>Брза дијагностика и грижа за вашиот уред</h2>
          <p>
            Брзо дијагностицирање, професионална поправка и замена на
            делови за вашиот мобилен телефон.
          </p>
        </div>

        {showSlider ? (
          <Swiper
            className="mySwiper"
            style={{ width: "100%", textAlign: "center", marginTop: "55px" }}
            pagination={{ dynamicBullets: true }}
            slidesPerView={slides}
            spaceBetween={16}
            modules={[Pagination, Navigation, Autoplay]}
            loop={true}
            navigation={true}
            autoplay={{ delay: 2600, disableOnInteraction: false }}
          >
            {services.map((service) => (
              <SwiperSlide key={service.title}>
                <SingleService {...service} />
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <div className="buzz-service-items" id="buzz-slider">
            {services.map((service) => (
              <div className="buzz-service-item" key={service.title}>
                <img src={service.img} alt={service.title} />
                <p>{service.title}</p>
              </div>
            ))}
          </div>
        )}

        <div className="services__button">
          <Link
            to="/servis"
            className="links hero-banner__button hero-banner__button--ghost"
          >
           СЕРВИС ЦЕНИ
          </Link>
        </div>
      </div>
    </section>
  );
}

export default ServiceHome;
